import { Component, Inject, LOCALE_ID, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from "@angular/router";
import { Location } from '@angular/common';
import { LoginService } from "../../services/login-service/login-service";
import { ProjectService } from "../../services/project-service/project-service";
import { RESOLVED_TOKEN } from "../../app.tokens";
import { Project } from '../../models/project.model';
import { Observable } from 'rxjs';
import {DataSharingService} from "../../services/login-service/data-sharing-service";

@Component({
//  providers: routingProviders,
  templateUrl: './admin-geheim.component.html',
  styleUrls: ['./admin-geheim.component.scss']
})

export class AdminGeheimComponent implements OnInit {
  public errorMessage: string = '';
  public jwtToken: string;
  public isAuthenticated = false;

  projects$: Observable<Project[]>;
  projects: Project[] = [];

  selectedProjectUUId: string = '';

  constructor(@Inject(LOCALE_ID) public locale: string,
              @Inject(RESOLVED_TOKEN) public localStorageToken: any,
              private location: Location,
              private loginService: LoginService,
              private projectService: ProjectService,
              private router: Router,
              private activatedRoute: ActivatedRoute,
              private dataSharingService: DataSharingService,
  ) {
    this.projects$ = projectService.projects$;

    this.jwtToken = localStorageToken();
    if (this.jwtToken.length == 0) {
      this.dataSharingService.setData('logout');
    }
  }

  ngOnInit() {
    const absoluteUrl = this.location.path().split('?')[0];
    let toTheTopAnchor = document.getElementById('to_the_top');
    if (toTheTopAnchor) {
      toTheTopAnchor.setAttribute("href", '/' + this.locale + absoluteUrl + '#start');
    }

    this.errorMessage =  'ich bin der Beste';
    if (this.jwtToken.length > 0) {
      this.projectService.loadAllProjects()
        .subscribe((projects: Project[]) => {
          this.projects.push(...projects);
        });
    } else {
      this.dataSharingService.setData('logout');
    }
  }

  selectProject(projectUUId: string = '') {
    this.selectedProjectUUId = projectUUId;

    this.router.navigate([ ], {
      relativeTo: this.activatedRoute
    });
  }
}
